import React from 'react';

const WIDTH_TYPES = {
  SHORT: 'short',
  MID: 'mid',
  LONG: 'long',
};

export const StatusTag = props => {
  const { type, short, long, children, ...restProps } = props;
  const statusType = type ? ` StatusTag--${type}` : ' ';
  let statusWidth = WIDTH_TYPES.MID;

  if (short) {
    statusWidth = WIDTH_TYPES.SHORT;
  }
  if (long) {
    statusWidth = WIDTH_TYPES.LONG;
  }

  const className = `StatusTag--${statusWidth}${statusType}`;

  return (
    <div className={className} {...restProps}>
      {children}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/StatusTag.jsx